import { useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { useCoordinator } from "@/shared/lib/hooks";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { journalsQueries } from "@entities/journal";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";

interface IUseSendToGSN {
  setIsLoading?: (value: boolean) => void;
  handleClear: () => void;
}

export const useSendToGSN = ({ setIsLoading, handleClear }: IUseSendToGSN) => {
  const { titleId } = useCoordinator();
  const queryClient = useQueryClient();

  const mutation = $journalApi.useMutation(
    "post",
    "/api/v1/journals/title/{titleId}/status/send",
  );

  const handleSendToGSN = async () => {
    setIsLoading?.(true);

    mutation.mutate(
      {
        params: { path: { titleId } },
      },
      {
        onSuccess: () => {
          notification.success({
            message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
            description: NOTIFICATION_MESSAGES.TITLE_SENT_TO_GSN_DESC, // "Титульный лист отправлен в ГСН"
            placement: "topRight",
          });
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getTitleJournal({ titleId }).queryKey,
          });
          handleClear();
        },
        onError: () => {
          notification.error({
            message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
            description: NOTIFICATION_MESSAGES.TITLE_SEND_TO_GSN_FAILED_DESC, // "Не удалось отправить титульный лист в ГСН"
            placement: "topRight",
          });
          handleClear();
        },
        onSettled: () => {
          setIsLoading?.(false);
        },
      },
    );
  };

  return { handleSendToGSN };
};

